import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link } from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from "axios";
import ytcLogo from "../../../../assets/images/logo.png";
// import logo from "../../../../assets/images/Numotalogo.png";
import numotaLogo from "../../../../assets/images/login-logo-nobg.png";
import Mainlogo from "../../../../assets/images/MainLogo.png";
import { NuInput, NuInputToggle } from "../../../../Components/Utils/Input";
import { useToast } from "../../../../Components/Others/ToastServices";
import CryptoJS from "crypto-js";
import ChangePassword from "./changePassword";
import "../../../../App.css";
import { GetDashboardRole } from "../../../../Components/Utils/roles";

axios.defaults.baseURL = window.WEB_APP_API_URL;
function AnotherLogin() {
  const toast = useToast();
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleForgetPasswordClick = () => {
    setShowForgetPassword(true);
  };
  const handleCloseModal = () => {
    setShowForgetPassword(false);
  };
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("nEkOtReSuEdArT") &&
      localStorage.getItem("sLiAtEdReSuEdArT") &&
      localStorage.getItem("sSeCcArEsUeDaRt")
    ) {
      window.location.replace(
        GetDashboardRole("")
          ? "/dashboard"
          : GetDashboardRole("sales")
            ? "/dashboard/sales"
            : GetDashboardRole("procurement")
              ? "/dashboard/procurement"
              : GetDashboardRole("store")
                ? "/dashboard/stores"
                : "#",
      );
    }
  }, []);

  const encryptData = async (data, location) => {
    let Test = JSON.stringify(data);
    const Value = CryptoJS.AES.encrypt(
      Test,
      process.env.REACT_APP_ACCESS_KEY,
    ).toString();
    localStorage.setItem(location, Value);
    // console.log('EnC',Value)
  };

  const [createNew, setCreateNew] = useState({
    email: "",
    password: "",
  });
  const formik = useFormik({
    initialValues: createNew,
    validateOnChange: false,
    validationSchema: yup.object({
      email: yup.string().required("Email is Required"),
      password: yup.string().required("Password is Required"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);
      await axios
        .post("/auth/login", value)
        .then(async (res) => {
          if (res.data.status) {
            setIsLoading(false);
            let userToken = res?.data?.token;
            await encryptData(userToken, "nEkOtReSuEdArT");
            if (res.data.refresh_token) {
              await encryptData(res.data.refresh_token, "nEkOtHsErFeRrEsUeDaRt");
            }
            let decodeToken = jwt_decode(res?.data?.token);
            await encryptData(decodeToken, "sLiAtEdReSuEdArT");
            let permissions = res?.data?.permissions;
            await encryptData(permissions, "sSeCcArEsUeDaRt");
            // localStorage.setItem('sLiAtEdReSuEdArT', JSON.stringify(decodeToken));
            // localStorage.setItem('nEkOtReSuEdArT', JSON.stringify(res?.data?.token));
            // localStorage.setItem('sSeCcArEsUeDaRt', JSON.stringify(res?.data?.permissions));
            toast.open({
              message: "Login successfully",
              description: res.data.msg || "Successfully logged in  ",
              type: "success",
            });
            window.location.replace(
              GetDashboardRole("")
                ? "/dashboard"
                : GetDashboardRole("sales")
                  ? "/dashboard/sales"
                  : GetDashboardRole("procurement")
                    ? "/dashboard/procurement"
                    : GetDashboardRole("store")
                      ? "/dashboard/stores"
                      : "/dashboard",
            );
          } else {
            setIsLoading(false);
            toast.open({
              message: "Login unsuccessfully",
              description: res.data.msg || "Login failed ",
              type: "error",
            });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.open({
            message: "Login unsuccessfully",
            description:
              err?.response.data.msg || "Login failed or network error  ",
            type: "error",
          });
        });
    },
  });

  return (
    <div className="w-full min-h-screen login-image flex flex-col justify-between p-3 sm:p-4 overflow-y-auto">
      <div className="w-full flex-1 flex items-center justify-center md:justify-end px-2 sm:px-4 md:px-0">
        <div className="w-full max-w-[360px] sm:max-w-[400px] md:w-[340px] lg:w-[380px] xl:w-[420px] mx-auto md:mx-0 md:mr-10 lg:mr-20 xl:mr-40 py-6 sm:py-8 px-4 sm:px-6 rounded-2xl bg-[#048178]/25 backdrop-blur-md flex justify-center items-center border border-white/40 shadow-2xl">
          <div className="w-full flex flex-col">
            <div className="w-[140px] sm:w-[160px] h-14 sm:h-16 rounded-[1.2rem] bg-[#e6f3f2] flex items-center justify-center gap-2 drop-shadow-md mx-auto mb-4 p-2">
              <img className="max-h-full max-w-full object-contain" src={ytcLogo} alt="logo" />
            </div>
            <form onSubmit={formik.handleSubmit} className="w-full">
              <div className="flex flex-col gap-1">
                <NuInput
                  type="text"
                  label="Email *"
                  placeholder="Enter Your Mail"
                  formik={formik}
                  name="email"
                  width="w-full"
                  padding="py-2"
                  color="white"
                />

                <NuInputToggle
                  label="Password *"
                  placeholder="************"
                  formik={formik}
                  name="password"
                  width="w-full"
                  padding="py-2"
                  color="white"
                />
              </div>

              <div className="flex justify-end mt-2">
                <span
                  onClick={handleForgetPasswordClick}
                  className="text-white font-sans text-xs sm:text-sm text-right cursor-pointer hover:underline"
                >
                  Forgot Password?
                </span>
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className={`w-full mt-6 h-10 rounded-md text-white text-xs sm:text-sm font-semibold transition-all duration-150 border-none ${isLoading
                  ? "cursor-wait bg-[#048178]/70"
                  : "cursor-pointer bg-[#048178] hover:bg-[#036861] active:scale-[0.99]"
                  }`}
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
      <p className="py-2 font-semibold text-center text-xs sm:text-sm text-slate-200">
        &#169; numota
      </p>
      {showForgetPassword && <ChangePassword onClose={handleCloseModal} />}
    </div>
  );
}
export default AnotherLogin;
